<form class="textInputBar" [formGroup]="messageForm">
  <div class="textInputBar__topRow">
    <div class="textInputBar__nickField" *ngIf="nickVisible">
      <input
      type="text"
      matInput 
      placeholder="Your nick*" 
      formControlName="nickname"
      required/>
    </div>
    <div class="textInputBar__termsWrap" *ngIf="acceptTermsEnable">
      <mat-checkbox type="checkbox" id="scales" name="terms" formControlName="termsaccept" required (change)="onCheckChange($event)"></mat-checkbox>
      <div for="terms"><a href="#" (click)="showTermsDialog($event)">Accept terms</a></div>
    </div>
  </div>
  <div class="textInputBar__imageAttach">
    <chat-image-attach (setImagesIsUploaded)="setImagesIsUploaded($event)" (maxAttachmentsExceeded)="showMaxAttachmentsExceeded()" maxAttachments="{{(isSpecialUser || PremiumAdvertisementMessages) ? 999 : userMaxImagesLength}}" [restartImagesCount]="restartImagesCount" #attachImage 
                  title="Drag files here or"></chat-image-attach>
  </div>
  <div class="textInputBar__emojiPicker">
    <emoji-picker *ngIf="isSpecialUser || PremiumAdvertisementMessages"
    (change)="updateMessage($event)" 
    [text]="textMessage"
    [element]="message">
   </emoji-picker>
  </div>
  <textarea matInput
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="8" class="textInputBar__message" type="text" 
            placeholder="message..."
            formControlName="messagecontent"
            required
            (blur)="contentBlur($event)" 
            [(ngModel)]="textMessage" #message></textarea>
  <button mat-icon-button class="btn border-0" [disabled]="submitInProgress" (click)="sendMessage(textMessage, currentConversation.conversationId || currentConversation)">
    <mat-icon aria-hidden="false" aria-label="send button" *ngIf="!submitInProgress">send</mat-icon>
    <mat-spinner class="textInputBar__loader" diameter="20" *ngIf="submitInProgress"></mat-spinner>
  </button>
</form>